import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getAuth, confirmPasswordReset } from 'firebase/auth';
import { Lock, CheckCircle, AlertTriangle, Loader2 } from 'lucide-react';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // Extraemos el código secreto que viene en el link del correo
  const oobCode = searchParams.get('oobCode'); 
  const returnPath = searchParams.get('return') || '/';

  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!oobCode) {
      setError("El enlace es inválido o está incompleto.");
      return;
    }
    if (newPassword.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      const auth = getAuth();
      // Le pasamos el código del link y la nueva contraseña a Firebase
      await confirmPasswordReset(auth, oobCode, newPassword);
      setMessage("¡Contraseña actualizada con éxito!");
      
      // 👇 Modificamos el setTimeout para que vuelva al local y mande la orden de abrir el login
      setTimeout(() => {
        navigate(`${returnPath}?action=login`);
      }, 3000);
      
    } catch (err) {
      console.error(err);
      setError("El enlace caducó o la contraseña no pudo ser actualizada.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md border border-gray-700 p-8 text-center">
        
        <img src="https://res.cloudinary.com/dz5ibyt7v/image/upload/v1793406258/barbergo-logo_tpj2tg.png" alt="BarberGo" className="h-9 mx-auto mb-6" />
        
        <h2 className="text-2xl font-bold text-white mb-2">Crear nueva contraseña</h2>
        <p className="text-gray-400 text-sm mb-6">Ingresa tu nueva contraseña para acceder a tu cuenta.</p>

        {error && (
          <div className="mb-4 p-3 bg-red-900/30 border border-red-500/50 rounded-lg flex items-center gap-2 text-red-200 text-sm text-left">
            <AlertTriangle className="w-5 h-5 shrink-0" /> {error}
          </div>
        )}

        {message ? (
          <div className="mb-6 p-4 bg-green-900/30 border border-green-500/50 rounded-xl flex flex-col items-center gap-3 text-green-400">
            <CheckCircle className="w-12 h-12" />
            <p className="font-bold">{message}</p>
            <p className="text-xs text-green-200">Redirigiendo al inicio de sesión...</p>
          </div>
        ) : (
          <form onSubmit={handleResetPassword} className="space-y-4">
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input 
                type="password" 
                required 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                className="w-full bg-gray-900 rounded-lg px-4 py-3 pl-10 text-white focus:ring-2 focus:ring-amber-500 outline-none border border-gray-700" 
                placeholder="Nueva contraseña (mínimo 6)" 
              />
            </div>

            <button type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-black font-bold py-3 rounded-lg transition-all shadow-lg flex items-center justify-center gap-2 disabled:opacity-50">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Guardar y Entrar'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;